import { toRaw } from "vue";
import { defineStore } from "pinia";

const isDesktop = () => screen.width > 760;

export const useMapStore = defineStore("mapStore", {
  state: () => ({
    map: null,
    _cachedCoordinates: null,
    _cachedZoom: null,
  }),

  getters: {
    center: (state) => {
      if (state.map) {
        const center = state.map.getCenter();

        return {
          latitude: center.lat(),
          longitude: center.lng(),
        };
      }

      return null;
    },
  },

  actions: {
    setMap(map) {
      this.map = map;

      if (this._cachedCoordinates) {
        this._setCenter(
          toRaw(this._cachedCoordinates),
          toRaw(this._cachedZoom),
        );

        this._cachedCoordinates = null;
        this._cachedZoom = null;
      }
    },

    setCenter(coordinates, zoom = null) {
      if (this.map) {
        this._setCenter(coordinates, zoom);
      } else {
        this._cachedCoordinates = coordinates;
        this._cachedZoom = zoom;
      }
    },

    _setCenter(coordinates, zoom = null) {
      this.map.setCenter({
        lat: coordinates.latitude,
        lng: coordinates.longitude,
      });

      if (zoom !== null) {
        if (isDesktop()) {
          this.map.setZoom(zoom.desktop);
        } else {
          this.map.setZoom(zoom.mobile);
        }
      }
    },
  },
});
